// extracted by mini-css-extract-plugin
export default {"multisignConfirmTxLink":"ZS8GwHDSAhG7Pc6BoQBg","centerAlign":"j8duH1VfbLZFp1ckhodN","sendBtnsWrapper":"ImyHzTUV9AMvfwV0EFQL","actionBtn":"MghTHJxhXuPRwyzuXq1S"};